import { Component } from 'react'
import * as styles from 'components/features/pfm/MoneyflowTrackers/MoneyflowTrackers.css'
import { ExtendedMoneyflowTracker, MoneyflowTyped } from 'interfaces/moneyflow'
import { CategoryId, CollectionCategory } from 'interfaces/meta'
import { TimeframeTyped } from 'interfaces/global'
import MoneyflowTracker from 'components/molecules/MoneyflowTracker'
import { Timeframe } from 'interfaces/chart'
import Anchor from 'components/atoms/navigation/Anchor'
import { AnchorPlacement } from 'interfaces/navigation'

export type MoneyflowTrackersStateProps = {
  expandedCategoryId: CategoryId | null
  trackers: ExtendedMoneyflowTracker[]
  categories: CollectionCategory

  selectedTimeframe: Timeframe
  selectedCategory: CategoryId
}

export type MoneyflowTrackersDispatchProps = {
  toggleTrackerDetails: (categoryId: CategoryId) => void
  setFilterCategory: (categoryId: CategoryId) => void
  setTimeframeCurrentMonth: () => void
  showTrackerPane: (categoryId: CategoryId) => void
}

// we need timeframe for breakdown loading
export type MoneyflowTrackersOwnProps =
  & MoneyflowTyped
  & TimeframeTyped

export type MoneyflowTrackersProps = MoneyflowTrackersStateProps & MoneyflowTrackersDispatchProps & MoneyflowTrackersOwnProps

class MoneyflowTrackers extends Component<MoneyflowTrackersProps, {}> {
  render () {
    const {
      type, expandedCategoryId,
      categories, trackers,
      selectedTimeframe, selectedCategory,
      setTimeframeCurrentMonth, setFilterCategory, toggleTrackerDetails,
      showTrackerPane,
    } = this.props

    const trackerItems = trackers.map((tracker) => {
      const { category: categoryId } = tracker
      const category = categories.byKey[categoryId]

      // TODO: unify this expandable layout with breakdowns
      return (
        <li key={ `${ type }_${ categoryId }` } className={ styles.trackerRow }>
          <MoneyflowTracker
            tracker={ tracker }
            category={ category }
            isExpanded={ expandedCategoryId === categoryId }
            toggleTrackerDetails={ toggleTrackerDetails }
            onClickEdit={ () => showTrackerPane(categoryId) }
            onClickView={ () => {
              selectedTimeframe !== 'current-month' && setTimeframeCurrentMonth()
              selectedCategory !== categoryId && setFilterCategory(categoryId)
            } }
          />
        </li>
      )
    })

    const anchorPlacement: AnchorPlacement = type === 'spending'
      ? 'dashboard_spending-trackers'
      : 'dashboard_income-trackers'

    return (
      <Anchor placement={ anchorPlacement }>
        <ul>{ trackerItems }</ul>
      </Anchor>
    )
  }
}

export default MoneyflowTrackers
